import { forwardRef } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { Slide } from "@mui/material";
import { isIOS } from "utils/device";

interface SlideTransitionProps extends TransitionProps {
  children: React.ReactElement;
}

const SlideUpTransition = isIOS()
  ? undefined
  : forwardRef<unknown, SlideTransitionProps>((props, ref) => <Slide direction='up' ref={ref} {...props} />);

export default SlideUpTransition;
